/**
 * OCR source badge — one shared label mapping for all review screens.
 *
 * The DB stores five possible `ocr_source` values ('tomarkdown' | 'glm-ocr' |
 * 'pdf-text' | 'qwen-ocr' | 'qwen-vl-ocr'); the old binary
 * `glm-ocr ? 'GLM-OCR' : 'toMarkdown'` rendering mislabeled everything else
 * as "toMarkdown" — e.g. Qwen-OCR'd statements (the majority) all wore a
 * "toMarkdown" badge (reported 2026-11-05, Hillcrest test 02 2025-04).
 */

const OCR_SOURCE_LABELS: Record<string, string> = {
  'tomarkdown': 'toMarkdown',
  'glm-ocr': 'GLM-OCR',
  'pdf-text': 'PDF text layer',
  'qwen-ocr': 'Qwen OCR',
  'qwen-vl-ocr': 'Qwen VL OCR',
};

/** Human label for a stored ocr_source; unknown/future values pass through. */
export function ocrSourceLabel(source?: string | null): string | null {
  if (!source) return null;
  return OCR_SOURCE_LABELS[source] || source;
}

/** Badge colours: LLM/vision OCR → green, text-layer extraction → blue. */
export function ocrSourceBadgeClass(source?: string | null): string {
  return source === 'glm-ocr' || source === 'qwen-ocr' || source === 'qwen-vl-ocr'
    ? 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400'
    : 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400';
}
